export default {"src":"/_next/static/media/brusselssprouts.4e6979fc.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};